// TYPES

import { Codec, number, string, GetInterface } from "purify-ts/Codec"

export enum AppState {
  DETECTING_BROWSER = "DETECTING_BROWSER",
  UNSUPPORTED_BROWSER = "UNSUPPORTED_BROWSER",
  LOADING = "LOADING",
  APP_READY = "APP_READY",
  FETCHING_FORM_QUERY = "FETCHING_FORM_QUERY",
  CONTRACT_PENDING = "CONTRACT_PENDING",
  DATA_READY = "DATA_READY",
  ERROR = "ERROR",
}

export interface AreaType {
  id: number
  navn: string
}

export const ContractArea = Codec.interface({
  id: number,
  navn: string,
})

export type ContractArea = GetInterface<typeof ContractArea>

export interface Contract {
  id: number
  filtype: "XLSX"
  navn: string
  nedlastLink: string
}
